import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module
import { parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table
export type Urgewald = {
  id: number;
  issuer_id: number | null;
  issuer_name?: string | null;
  date: string | null;
  installed_coal_power_capacity: number | null;
  annual_coal_production: number | null;
  coal_share_power_production: number | null;
  coal_share_revenue: number | null;
  unconventional_production: number | null;
  unconventional_production_fracking: number | null;
  unconventional_production_tar_sands: number | null;
  unconventional_production_coalbed_methane: number | null;
  unconventional_production_extra_heavy_oil: number | null;
  unconventional_production_ultra_deepwater: number | null;
  unconventional_production_arctic: number | null;
  is_developer: boolean | null;
  created_at: string;
  updated_at: string;
};

// Definition of the columns
export const urgewalds_columns: ColumnDef<Urgewald>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "issuer_name",
    header: "Issuer Name",
    cell: ({ row }) => {
      const issuerId = row.original.issuer_id;
      const name = row.getValue<string | null>("issuer_name");
      return issuerId && name ? (
        <Link
          href={toWorkspacePath(`/admin/qtl - referential/issuers/${issuerId}`)}
          className="text-xs"
          underline="hover"
        >
          {name || ""}
        </Link>
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "date",
    header: "Date",
    cell: ({ row }) => parseDate(row.getValue("date")),
  },
  {
    accessorKey: "installed_coal_power_capacity",
    header: "Installed Coal Power Capacity",
    cell: ({ row }) => {
      const value = row.getValue("installed_coal_power_capacity");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "annual_coal_production",
    header: "Annual Coal Production",
    cell: ({ row }) => {
      const value = row.getValue("annual_coal_production");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "coal_share_power_production",
    header: "Coal Share Power Production",
    cell: ({ row }) => {
      const value = row.getValue("coal_share_power_production");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "coal_share_revenue",
    header: "Coal Share Revenue",
    cell: ({ row }) => {
      const value = row.getValue("coal_share_revenue");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "unconventional_production",
    header: "Unconventional Production",
    cell: ({ row }) => {
      const value = row.getValue("unconventional_production");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "unconventional_production_fracking",
    header: "Unconventional Production Fracking",
    cell: ({ row }) => {
      const value = row.getValue("unconventional_production_fracking");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "unconventional_production_tar_sands",
    header: "Unconventional Production Tar Sands",
    cell: ({ row }) => {
      const value = row.getValue("unconventional_production_tar_sands");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "unconventional_production_coalbed_methane",
    header: "Unconventional Production Coalbed Methane",
    cell: ({ row }) => {
      const value = row.getValue("unconventional_production_coalbed_methane");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "unconventional_production_extra_heavy_oil",
    header: "Unconventional Production Extra Heavy Oil",
    cell: ({ row }) => {
      const value = row.getValue("unconventional_production_extra_heavy_oil");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "unconventional_production_ultra_deepwater",
    header: "Unconventional Production Ultra Deepwater",
    cell: ({ row }) => {
      const value = row.getValue("unconventional_production_ultra_deepwater");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "unconventional_production_arctic",
    header: "Unconventional Production Arctic",
    cell: ({ row }) => {
      const value = row.getValue("unconventional_production_arctic");
      return value !== null && value !== undefined
        ? Number(value).toFixed(4)
        : "";
    },
  },
  {
    accessorKey: "is_developer",
    header: "Is Developer",
    cell: ({ row }) => (row.getValue("is_developer") ? "Yes" : "No"),
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue("created_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          Éditer
        </Link>
      </div>
    ),
  },
];
